<template>
    <div>
      <h1>Contact Us</h1>
      <p>Get in touch with us for any inquiries or support.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ContactUsIndex',
  };
  </script>
  
  <style scoped>
  /* Add your styles here */
  </style>